<script setup>
const sections = [
  {
    texts: [
      'Diese AGB gelten für den Geschäftsbereich der RAUMPIONIERE AG, Bahnhofstrasse 6, 9000 St. Gallen.',
      'Wir RAUMPIONIERE besitzen und betreiben eine eigene Plattform und erbringen darauf entgeltliche und unentgeltliche Dienstleistungen im Zusammenhang mit Raumplanung, Verdichtung, Energie und weiteren Themen.',
      'Die Plattform wird mit verschiedenen URLs aufgerufen. Zudem bieten wir RAUMPIONIERE Beratungsdienstleistungen an und erteilen Lizenzrechte. Ausserdem verkaufen wir Produkte im obengenannten Bereich.',
      'Diese AGB gelten für die obengenannten Bereiche sowie alle weiteren Dienstleistungen, die wir RAUMPIONIERE direkt und indirekt gegenüber Kunden erbringen.'
    ]
  },
  {
    title: 'Vertragsabschluss',
    texts: [
      'Der Vertragsabschluss kommt durch die Akzeptanz der Offerte von uns RAUMPIONIEREN betreffend den Bezug von Dienstleistungen, Produkten oder Lizenzen durch den Kunden zustande.',
      'Der Vertrag kommt ausserdem zustande, wenn der Kunde die von uns angebotenen Dienstleistungen in Anspruch nimmt oder Produkte von uns bezieht oder benutzt (Lizenz).'
    ]
  },
  {
    title: 'Preise',
    texts: [
      'Vorbehaltlich anderweitiger Offerten verstehen sich alle Preise in Schweizer Franken (CHF).',
      'Alle Preise verstehen sich exklusive allfällig anwendbarer Mehrwertsteuer (MwSt) und weiteren allfällig anwendbaren Steuern.',
      'Wir RAUMPIONIERE behalten uns vor, die Preise jederzeit zu ändern. Es gelten die zum Zeitpunkt des Vertragsabschlusses auf der Plattform oder in einer separaten Preisliste gültigen Preise. Für den Kunden gelten die zum Zeitpunkt des Vertragsabschlusses gültigen Preise.'
    ]
  },
  {
    title: 'Bezahlung',
    texts: [
      'Der Kunde ist verpflichtet, den in Rechnung gestellten Betrag innert 30 Tagen ab Rechnungsdatum zu bezahlen – es sei denn, er habe den Betrag bereits beim Bestellvorgang via Kreditkarte, Paypal oder anderen Zahlungssystemen beglichen.',
      'Wird die Rechnung nicht binnen vorgenannter Zahlungsfrist beglichen, wird der Kunde gemahnt. Begleicht der Kunde die Rechnung nicht binnen der angesetzten Mahnfrist, fällt er automatisch in Verzug. Ab Zeitpunkt des Verzuges schuldet der Kunde Verzugszinsen in der Höhe von 5%.',
      'Wir RAUMPIONIERE behalten uns vor, jederzeit ohne Angabe von Gründen Vorauskasse zu verlangen.',
      'Eine Verrechnung des in Rechnung gestellten Betrages mit einer allfälligen Forderung des Kunden gegen uns RAUMPIONIERE ist nicht zulässig.',
      'Uns RAUMPIONIEREN steht das Recht zu, bei Zahlungsverzug die Dienstleistungserbringung, die Lieferung des Produkts oder die Gewährung der Lizenz zu verweigern.'
    ]
  },
  {
    title: 'Unsere Pflichten',
    texts: [
      'Dienstleistungserbringung',
      'Vorbehaltlich anderslautender Vereinbarung erfüllen wir RAUMPIONIERE unsere Verpflichtung durch die Erbringung der vereinbarten Dienstleistung. Die Dienstleistung beinhaltet die Leistungen, welche zum Zeitpunkt des Vertragsschlusses in einer Offerte oder online publiziert sind oder waren.',
      'Einen Grossteil unserer Dienstleistungen erbringen wir online. Für alle weiteren Dienstleistungen gilt unser Sitz als Erfüllungsort – es sei denn, es werden anderweitige Bestimmungen getroffen.'
    ]
  },
  {
    title: 'Hilfspersonen',
    texts: [
      'Wir haben das ausdrückliche Recht, zur Erledigung unserer vertragsgemässen Pflichten Hilfspersonen beizuziehen. Dabei haben wir sicherzustellen, dass der Beizug der Hilfsperson unter Einhaltung aller zwingenden gesetzlichen Bestimmungen und allfälliger Gesamtarbeitsverträge erfolgt.'
    ]
  },
  {
    title: 'Lizenz'
  },
  {
    title: 'Nutzung',
    texts: [
      'Wir RAUMPIONIERE gewähren dem Kunden das Recht, die Dienste und die Software unserer Plattform zu nutzen. Diese Nutzungsrechte sind nicht exklusiv, unübertragbar und auf die Nutzung durch den Kunden beschränkt.',
      'Die einzelnen Dienste und Anwendungen dürfen vom Kunden lediglich für interne Zwecke genutzt werden.',
      'Jegliche Weitergabe an Dritte sowie anderweitige Nutzung kommerzieller oder anderer Natur ist untersagt.',
      'Der unter Open Source publizierte Programmiercode unterliegt der jeweiligen deklarierten Lizenz.'
    ]
  },
  {
    title: 'Speichern und Anpassen',
    texts: [
      'Das Speichern und Kopieren jeglicher Daten unserer Plattform ist untersagt. Auch ein Zwischenspeichern und jegliche technischen Möglichkeiten, um die Serviceabfragen zu minimieren, sind nicht erlaubt.',
      'Die Dienste sind in ihrer Form zu verwenden, wie sie von uns RAUMPIONIEREN zur Verfügung gestellt werden. Anpassungen und Modifikationen der Dienste sind nicht zulässig.'
    ]
  }, {
    title: 'Befristung',
    texts: [
      'Die Dienste und Anwendungen unserer Plattform stehen dem Kunden für die vereinbarte Dauer zur Verfügung. Nach Ablauf dieser Frist hat der Kunde keinen Anspruch mehr auf unsere Plattform.'
    ]
  }, {
    title: 'Pflichten des Kunden'
  }, {
    title: 'Ausübung der Nutzungsrechte',
    texts: [
      'Der Kunde ist verpflichtet, die Nutzungsrechte lediglich im gewährten Umfang auszuüben.',
      'Der Kunde ist für die sichere Aufbewahrung seiner Zugangsdaten und Passwörter vollumfänglich verantwortlich.',
      'Für den Inhalt der erfassten Daten und Informationen ist der Kunde selbst verantwortlich.',
      'Der Kunde ist verpflichtet, sämtliche Vorkehrungen, welche zur Erbringung der Dienstleistung durch uns RAUMPIONIERE erforderlich sind, umgehend vorzunehmen.',
      'Der Kunde hat die Vorkehrungen am vereinbarten Ort zur vereinbarten Zeit und im vereinbarten Mass vorzunehmen. Je nach Umständen gehört dazu auch das Erbringen geeigneter Informationen und Unterlagen an uns RAUMPIONIERE.',
      'Der Kunde bestätigt mit dem Akzeptieren der vorliegenden AGB zudem, dass er über eine unbeschränkte Handlungsfähigkeit verfügt und volljährig ist.',
      'Der Kunde erklärt mit der Registrierung ausdrücklich, dass sämtliche gemachten Angaben der Wahrheit entsprechen, aktuell sind und mit den Rechten Dritter, den guten Sitten und dem Gesetz in Übereinstimmung sind.'
    ]
  },
  {
    title: 'Mitwirkungspflichten',
    texts: [
      'Der Kunde ist zur umfassenden und prompten Mitwirkung verpflichtet. Er hat uns RAUMPIONIERE jegliche im Zusammenhang mit der Dienstleistungserbringung erforderlichen Unterlagen unaufgefordert, vollständig und inhaltlich korrekt zu übergeben.',
      'Wir RAUMPIONIERE gehen davon aus, dass die gelieferten Informationen und Unterlagen richtig und vollständig sind sowie den gesetzlichen Mitwirkungs- und Auskunftspflichten entsprechen.',
      'Die Prüfung der Richtigkeit und Ordnungsmässigkeit von Informationen, Unterlagen und Zahlen des Kunden obliegt uns RAUMPIONIEREN nur, wenn dies vorab schriftlich vereinbart wurde.'
    ]
  },
  {
    title: 'Weitere Pflichten',
    texts: [
      'Der Kunde ist für die sichere Aufbewahrung seiner Zugangsdaten und Passwörter vollumfänglich verantwortlich. Für den Inhalt der erfassten Daten und Informationen ist der Kunde selbst verantwortlich.',
      'Wir RAUMPIONIERE sind berechtigt, das Verhalten der Kunden im Zusammenhang mit der Nutzung der Plattform zu kontrollieren. Wir RAUMPIONIERE sind insbesondere berechtigt, die vom Kunden auf der Plattform erfassten Inhalte jederzeit auf ihre Rechtmässigkeit zu überprüfen.'
    ]
  },
  {
    title: 'Rücktritt'
  }, {
    title: 'Dienstleistungen',
    texts: [
      'Beide Parteien haben das Recht, jederzeit vom Vertrag zurück zu treten.',
      'Die zurücktretende Partei hat die bereits getätigten Aufwendungen der anderen Partei vollumfänglich zu entgelten.',
      'Ein Rücktritt zu Unzeiten ist nicht zulässig.',
      'Es werden dem Kunden die durch den Rücktritt verursachten Kosten in Rechnung gestellt. Der genaue Betrag wird dem Kunden bei Vertragsabschluss mitgeteilt.'
    ]
  },
  {
    title: 'Produkte',
    texts: [
      'Ein Umtausch von Produkten ist grundsätzlich ausgeschlossen.'
    ]
  }, {
    title: 'Lizenz',
    texts: [
      'Der Kunde erhält von uns RAUMPIONIEREN das Recht, die Plattform für die vereinbarte Dauer zu nutzen.',
      'Ein Rücktritt nach der Bestellung ist nicht mehr möglich, selbst wenn unsere Plattform nicht genutzt wurde.',
      'Das vereinbarte Entgelt ist für die vertragliche Dauer geschuldet.'
    ]
  },
  {
    title: 'Upgrade / Add-on',
    texts: [
      'Ein Upgrade von einem kleineren zu einem grösseren Paket ist jederzeit möglich. Ein Downgrade ist dagegen ausgeschlossen.',
      'Hat der Kunde ein grösseres Paket gewählt und bezieht nicht alle Leistungen, hat er keinen Anspruch auf eine Rückvergütung.',
      'Zum Paket hinzugewählte Add-ons können zu einem späteren Zeitpunkt nicht mehr abgewählt werden.',
      'Wurde die Leistung eines Add-ons erbracht, wird es voll verrechnet, jede Rückvergütung von nicht genutzten Add-ons wird ausgeschlossen.'
    ]
  },
  {
    title: 'Eigentum und Nutzung',
    texts: [
      'Das Eigentum an den Produkten bleibt vollständig bei uns RAUMPIONIEREN.',
      'Der Kunde kauft mit einem Produkt das Recht für die Nutzung des Produkts über eine bestimmte Dauer ein.',
      'Bis zur vollständigen Bezahlung des Kaufpreises bei uns RAUMPIONIEREN darf der Kunde nicht über die Produkte verfügen, insbesondere sie weder verkaufen noch vermieten, verpfänden oder anderwärtig übertragen.'
    ]
  },
  {
    title: 'Gewährleistung',
    texts: [
      'Wir RAUMPIONIERE kümmern uns um eine gute Verfügbarkeit unserer Plattform und unternehmen angemessene Vorkehrungen, um sie vor Eingriffen Dritter zu schützen.',
      'Wir RAUMPIONIERE können jedoch keine Gewährleistung für ein unterbruch- und störungsfreies Funktionieren der Plattform und den angebotenen Dienstleistungen geben und auch nicht gewährleisten, dass die Dateien virenfrei sind.',
      'Wir RAUMPIONIERE leisten keine Gewähr für die sachliche und inhaltliche Korrektheit, Vollständigkeit und Zuverlässigkeit oder Qualität der publizierten oder übermittelten Informationen und Unterlagen sowie des Arbeitsresultats der Dienstleistungen.',
      'Wir RAUMPIONIERE können zudem keine Gewährleistung geben für schädliche Software, Spyware, Hacker oder Phishing-Angriffe etc., welche die Benutzung der Dienstleistung beeinträchtigen, die Infrastruktur (z.B. Endgeräte, PC) des Kunden beschädigen oder ihn anderweitig schädigen.',
      'Ein allfälliges Problem oder ein Defekt ist uns RAUMPIONIEREN umgehend anzuzeigen.',
      'Ein allfälliger Mangel ist uns RAUMPIONIEREN umgehend anzuzeigen. Es steht uns RAUMPIONIEREN zu, zu entscheiden, ob das mangelhafte Produkt repariert oder ersetzt wird. Nur wenn ein Ersatz oder eine Reparatur nicht möglich ist, hat der Kunde Anspruch auf eine Minderung oder Rückerstattung des Kaufpreises. Der Anspruch auf Kostenrückerstattung bei Fremdreparaturen wird ausgeschlossen. Während der Zeit der Reparatur hat der Kunde keinen Anspruch auf ein Ersatzprodukt. Die Gewährleistung beginnt für das reparierte Element neu zu laufen, für die restlichen Elemente des Produkts läuft die ursprüngliche Gewährleistungsfrist weiter.'
    ]
  },
  {
    title: 'Haftung',
    texts: [
      'Die Haftung für jegliche indirekten Schäden und Mangelfolgeschäden schliessen wir vollumfänglich aus.',
      'Die Haftung für direkte Schäden ist auf die Summe der vom Kunden erworbenen Dienstleistung, des Produkts oder der Lizenz beschränkt. Diese Haftungsbeschränkung gilt nicht für direkte Schäden verursacht durch Grobfahrlässigkeit oder Absicht.',
      'Wir RAUMPIONIERE übernehmen keine Haftung bei unabsichtlicher Verletzung Rechte Dritter.',
      'Der Kunde ist verpflichtet, allfällige Schäden umgehend uns RAUMPIONIERE zu melden.',
      'In keinem Fall können die an der Entwicklung sowie Aufbereitung der Daten beteiligten Personen oder Hilfspersonen für jeglichen Schaden haftbar gemacht werden, egal, aus welchem Grund der Schaden entstanden ist.'
    ]
  },
  {
    title: 'Immaterialgüterrechte',
    texts: [
      'Sämtliche Rechte an den Produkten, Dienstleistungen und allfälligen Marken stehen uns RAUMPIONIEREN zu – oder wir sind zu deren Benutzung vom Inhaber berechtigt.',
      'Weder diese AGB noch dazugehörige Individualvereinbarungen haben die Übertragung von Immaterialgüterrechten zum Inhalt, es sei denn, dies werde explizit erwähnt.',
      'Zudem ist jegliche Weiterverwendung, Veröffentlichung und das Zugänglichmachen von Informationen, Bildern, Texten oder Sonstigem, welches der Kunde im Zusammenhang mit diesen Bestimmungen erhält, untersagt, es sei denn, es werde von uns RAUMPIONIEREN explizit genehmigt.',
      'Verwendet der Kunde im Zusammenhang mit uns RAUMPIONIEREN Inhalte, Texte oder bildliches Material, an welchem Dritte ein Schutzrecht haben, hat der Kunde sicherzustellen, dass keine Schutzrechte Dritter verletzt werden.'
    ]
  }, {
    title: 'Datenschutz',
    texts: [
      'Informationen zu unseren Datenschutzbestimmungen finden Sie unter Datenschutz. '
    ]
  },
  {
    title: 'Änderungen',
    texts: [
      'Diese AGB können von uns RAUMPIONIEREN jederzeit geändert werden.',
      'Die neue Version tritt durch die Publikation auf unserer Webseite raumpioniere.ch in Kraft.',
      'Für die Kunden gilt grundsätzlich die Version der AGB, welche zum Zeitpunkt des Vertragsabschlusses in Kraft ist. Es sei denn, der Kunde habe einer neueren Version der AGB zugestimmt.'
    ]
  },
  {
    title: 'Priorität',
    texts: [
      'Diese AGB gehen allen älteren Bestimmungen und Verträgen vor. Lediglich Bestimmungen aus Individualverträgen, welche die Bestimmungen dieser AGB noch spezifizieren, gehen diesen AGB vor.'
    ]
  },
  {
    title: 'Salvatorische Klausel',
    texts: [
      'Sollte eine Bestimmung dieses Vertrages oder eine Beilage dieses Vertrages ungültig sein oder werden, so wird dadurch die Wirksamkeit des Vertrages im Übrigen nicht berührt. Die Vertragsparteien werden die unwirksame Bestimmung durch eine wirksame Bestimmung ersetzen, die dem gewollten wirtschaftlichen Zweck der ungültigen Bestimmung möglichst nahekommt. Dasselbe gilt auch für allfällige Vertragslücken.'
    ]
  },
  {
    title: 'Vertraulichkeit',
    texts: [
      'Die Vertragsparteien sowie deren Hilfspersonen verpflichten sich, sämtliche Informationen, welche im Zusammenhang mit den Leistungen unterbreitet oder angeeignet wurden, vertraulich zu behandeln. Diese Pflicht bleibt auch nach der Beendigung des Vertrages bestehen.'
    ]
  },
  {
    title: 'Höhere Gewalt',
    texts: [
      'Wird die fristgerechte Erfüllung durch uns RAUMPIONIERE, deren Lieferanten oder beigezogenen Dritten infolge höherer Gewalt wie beispielsweise Naturkatastrophen, Erdbeben, Vulkanausbrüche, Lawinen, Unwetter, Gewitter, Stürme, Kriege, Unruhen, Bürgerkriege, Revolutionen und Aufstände, Terrorismus, Sabotage, Streiks, Atomunfälle resp. Reaktorschäden verunmöglicht, so sind wir RAUMPIONIERE während der Dauer der höheren Gewalt sowie einer angemessenen Anlaufzeit nach deren Ende von der Erfüllung der betroffenen Pflichten befreit.',
      'Dauert die höhere Gewalt länger als 30 Tage können wir RAUMPIONIERE vom Vertrag zurücktreten.',
      'Wir RAUMPIONIERE haben dem Kunden bereits geleistetes Entgelt vollumfänglich zurückzuerstatten.',
      'Jegliche weiteren Ansprüche, insbesondere Schadenersatzansprüche infolge vis major sind ausgeschlossen.'
    ]
  },
  {
    title: 'Anwendbares Recht / Gerichtsstand',
    texts: [
      'Auf dieses Vertragsverhältnis findet Schweizer Recht Anwendung, und zwar unter Ausschluss der Bestimmungen des internationalen Privatrechts.',
      'Ausschliesslicher Gerichtsstand ist St. Gallen, Schweiz.',
      'Das Übereinkommen der Vereinten Nationen über Verträge über den internationalen Produktekauf (SR 0.221.221.1) wird explizit ausgeschlossen.'
    ]
  },
  {
    title: 'St. Gallen, März 2022'
  }
]
</script>

<template lang='pug'>
.full-width
  .routerPageSize
    .privacyContainer
      .header
        div Unsere
        div Allgemeinen Geschäftsbedingungen.
      .sectionsContainer
        .section(v-for="(section, index) in sections" :key="index")
          .sectionTitle.sectionText(v-if="section.title") {{ section.title }}
          .column(v-if="section.texts")
            .sectionText(v-for="text in section.texts" :key="text") {{ text }}
</template>

<style lang='sass'>
.privacyContainer
  padding: 20px 0 60px 0
  .header
    @media screen and (min-width: 1024px)
      margin: 40px 0
      font-weight: 800
      font-size: 50px
      line-height: 130%
      color: #2F3849
    @media screen and (max-width: 1023px)
      font-weight: 700
      color: #2F3849
      font-size: 20px
      line-height: 130%
  .sectionsContainer
    margin: 20px 0
    .sectionTitle
      @media screen and (min-width: 1024px)
        padding: 40px 0 20px 0
      @media screen and (max-width: 1023px)
        padding: 20px 0 10px 0
    .sectionText
      @media screen and (min-width: 1024px)
        font-weight: 700
        font-size: 16px
        line-height: 130%
        color: #626C85
      @media screen and (max-width: 1023px)
        font-weight: 500
        font-size: 12px
        line-height: 130%
        color: #626C85
</style>
